import React from 'react';
import { Switch, Route } from 'react-router-dom';
import $ from 'jquery';
import AppProvider from './AppProvider';
import MainFetch from './main/MainFetch';
import Loadable from './common/Loadable';
import Notifications from './components/notifications/Notifications';
import Analytics from './common/analytics/Analytics';
import { createStore } from './store/store';
import { initRoot } from './store/actions/init';

class App extends React.Component {
  constructor(props) {
    super(props);

    window.__cache__ = new Map();
    window.$ = $;
    window.__store__ = createStore();
    window.__store__.dispatch(initRoot());
  }

  componentDidMount() {
    $.ajaxSetup({ cache: true });
    $(document).foundation();
  }

  render() {
    return (
      <AppProvider>
        <Switch>
          <Route
            path="/features"
            render={() => (
              <Loadable
                loader={() => import('./components/features/FeaturesFetch')}
                render={FeaturesFetch => <FeaturesFetch />}
              />
            )}
          />
          <Route path="/" render={() => <MainFetch />} />
        </Switch>
        <Notifications />
        <Route>{({ location }) => <Analytics location={location} />}</Route>
      </AppProvider>
    );
  }
}

export default App;
